import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BackgroundImgSet } from 'libs/core/src/lib/pipes/background-image-set.pipe';

@Component({
  selector: 'lib-background-overlay',
  templateUrl: './background-overlay.component.html',
  styleUrls: ['./background-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BackgroundImgSet],
})
export class BackgroundOverlayComponent {
  imageUrl = input<string | string[]>('');
}
